import BModalHistory from './BModalHistory';
export default BModalHistory;
